<template>
  <div>
    <h2 class="font-bold text-xl mb-6">Emails</h2>
    <div class="  mb-4 ">
      <p class="font-semibold text-sm mb-2">Template List</p>
      <base-input>
        <select class="form-control">
          <option disabled="true">Select</option>
          <option>Happy Holi Template</option>
          <option>Republic Day Template</option>
        </select>
      </base-input>
    </div>
    <div class=" mb-4 ">
      <p class="font-semibold text-sm mb-2">Subject</p>
      <b-input placeholder="Enter Subject..." />
    </div>
    <div class=" mb-4 ">
      <p class="font-semibold text-sm mb-2">From</p>
      <b-input
        placeholder="Enter Landing page URL..."
        :disabled="true"
        value="ABC"
      />
    </div>
    <TextEditor />
  </div>
</template>

<script>
import TextEditor from "./TextEditor.vue";

export default {
  components: {
    TextEditor
  }
};
</script>
